import { render, staticRenderFns } from "./DeliveryBillDetailSerialNoList.vue?vue&type=template&id=484561c6&"
import script from "./DeliveryBillDetailSerialNoList.vue?vue&type=script&lang=js&"
export * from "./DeliveryBillDetailSerialNoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports